import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import ActionService from "../action.service";
import {Observable, of} from "rxjs";
import {environment} from "../../environments/environment";
import Pagination from "../../model/pagination";
import QueryEncoder from "../queryEncoder";
import {catchError, switchMap} from "rxjs/operators";
import InvoiceModel from "../../model/invoice.model";
import GoalModel from "../../model/goal.model";

@Injectable()
export default class GoalService {
    public constructor(private http: HttpClient, private actionService: ActionService) {
    }

    public show(id): Observable<GoalModel> {
        return this.http.get<GoalModel>(environment.apiUrl + '/goals/' + id);
    }

    public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string, additionalFields?: any): Observable<Pagination<GoalModel>> {
        if(typeof query !== 'string') {
            query = '';
        }
        query = query || '';
        page = page || 1;
        limit = limit || 15;
        sort = sort || '';

        let sorting = {};
        sorting[sort] = direction;

        const q = {query, page, limit, sorting};

        if(additionalFields) {
            Object.assign(q, additionalFields);
        }

        return this.http.get<Pagination<GoalModel>>(environment.apiUrl + '/goals?' + QueryEncoder.encodeURI(q));
    }

    public delete(goal: GoalModel): Observable<boolean> {
        return this.http.delete(environment.apiUrl + '/goals/' + goal.id).pipe(switchMap(result => of(true)), catchError(err => of(false)));
    }

    public update(goal: GoalModel): Observable<GoalModel> {
        return this.http.put<GoalModel>(environment.apiUrl + '/goals/' + goal.id, goal);
    }

    public create(goal: GoalModel): Observable<any> {
        return this.http.post(environment.apiUrl + '/goals', goal);
    }
}
